import {
  ButtonList,
  DropdownButton,
  DropdownButtonContext,
} from '@dixa/lib-shared-habla';

import styles from './contactTypeDropdown.module.scss';

type ContactTypeDropdownProps = {
  /** The currently selected contact type */
  selected: ContactType;
  /** Callback when the contact type changes */
  onChange: (value: ContactType) => void;
};

const CONTACT_TYPE_LABELS: Record<ContactType, string> = {
  user: 'Contacts',
  company: 'Companies',
};

const CONTACT_TYPES = ['user', 'company'] as const;

type ContactType = (typeof CONTACT_TYPES)[number];

/** Represents a dropdown component that is used to select a contact type */
export const ContactTypeDropdown = ({
  selected,
  onChange,
}: ContactTypeDropdownProps): JSX.Element => {
  return (
    <DropdownButton
      buttonProps={{ variant: 'tertiary' }}
      dropdown={
        <DropdownButtonContext.Consumer>
          {({ toggleDropdown }) => (
            <ButtonList>
              {CONTACT_TYPES.map((value) => (
                <ButtonList.Item
                  key={value}
                  isSelected={value === selected}
                  onClick={() => {
                    toggleDropdown();
                    onChange(value);
                  }}
                >
                  {CONTACT_TYPE_LABELS[value]}
                </ButtonList.Item>
              ))}
            </ButtonList>
          )}
        </DropdownButtonContext.Consumer>
      }
      className={styles.root}
    >
      {CONTACT_TYPE_LABELS[selected]}
    </DropdownButton>
  );
};
